module.exports = __webpack_public_path__ + "img/open_sided_and_attached_to_main_house_with_connected_concrete_roof_system.22a32093.jpg";